// Compteur « 01 / 04 » de la vitrine des services : suit l'onglet actif.
// Bootstrap émet `shown.bs.tab` sur l'onglet activé ; on n'y ajoute que la mise à jour du
// libellé, l'activation elle-même restant entièrement gérée par Bootstrap.
document.addEventListener('DOMContentLoaded', () => {
  for (const showcase of document.querySelectorAll('.services-showcase')) {
    const output = showcase.querySelector('[data-svc-current]')
    if (!output) {
      continue
    }

    showcase.addEventListener('shown.bs.tab', (event) => {
      const index = event.target.dataset.svcIndex
      if (index) {
        output.textContent = index
      }
    })
  }
})
